import {
  EditItemPreloadConfiguration,
  FileURL,
  OptionSelection,
  PreloadConfiguration,
  SelectionAction,
  SelectionState,
} from '../../types'
import uniqBy from 'lodash/uniqBy'
import isEmpty from 'lodash/isEmpty'

export default function reducer(
  state: SelectionState,
  action: SelectionAction
): SelectionState {
  switch (action.type) {
    case 'OPTION_SELECT': {
      // The validity of those selected options will be valid and get rid off when
      //  component use selectorsConfiguration to access selector configuration
      //  it won't handle anything here, just simply insert the values to the top
      //  and dedup it.

      let currentValues = state.values
      const payload = action.payload as OptionSelection
      // Insert current selection on top to take the highest precedent
      currentValues.unshift(payload)
      currentValues = uniqBy(currentValues, 'name')

      return {
        ...state,
        selectedOptionLabel: payload.name,
        values: currentValues,
      }
    }
    case 'UPLOAD_FILE': {
      const newFiles = action.payload as FileURL[]
      return {
        ...state,
        forceResetUploadDropzone: false,
        filesUrls: [...newFiles, ...state.filesUrls],
      }
    }
    case 'REMOVE_UPLOAD_FILE': {
      const toBeRemovedFileUrl = action.payload as FileURL
      return {
        ...state,
        filesUrls: state.filesUrls.filter(
          (fileUrl) => fileUrl !== toBeRemovedFileUrl
        ),
      }
    }
    case 'CLEAR_UPLOADED_FILES': {
      return {
        ...state,
        filesUrls: [],
        forceResetUploadDropzone: true,
      }
    }
    case 'RESET_PRODUCT_OPTION': {
      return {
        ...state,
        values: [],
      }
    }
    case 'PRELOAD_CONFIGURATION': {
      const currentValues = state.values
      const preloadConfiguration = action.payload as PreloadConfiguration
      const { options = [], filesUrls = [] } = preloadConfiguration
      const itemId =
        'itemId' in preloadConfiguration
          ? (preloadConfiguration as EditItemPreloadConfiguration).itemId
          : null

      return {
        ...state,
        ...(isEmpty(options)
          ? {}
          : { values: uniqBy([...options, ...currentValues], 'name') }),
        ...(isEmpty(filesUrls) ? {} : { filesUrls }),
        ...(itemId ? { itemId } : {}),
      }
    }
    default:
      throw new Error('Invalid action')
  }
}
